// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min
}

let endTimeG
let spImgList = [
//   'https://cdn.shopify.com/s/files/1/0717/2712/0602/files/2_cd580464-29d4-4dad-a60a-a0628d78298b.png?v=1765266639',
//   'https://cdn.shopify.com/s/files/1/0717/2712/0602/files/5_df8258a6-ecb8-41aa-87c3-b5e305e81fc9.png?v=1765266639',

//   'https://cdn.shopify.com/s/files/1/0717/2712/0602/files/8_67accdd7-6f9f-4572-9b8c-df29645d19fb.png?v=1765266639',
//   'https://cdn.shopify.com/s/files/1/0717/2712/0602/files/2_f90c42da-9c95-406e-b63c-a9af5806e0fb.png?v=1765266639',
//   'https://cdn.shopify.com/s/files/1/0717/2712/0602/files/5_6d06681e-9237-417a-a546-c3251e57e60a.png?v=1765266639',
//   'https://cdn.shopify.com/s/files/1/0717/2712/0602/files/8_8d83f10f-e6b5-4e3e-b6ac-b440bc9ca197.png?v=1765266639',
    'https://cdn.shopify.com/s/files/1/0660/0527/0775/files/20250930-p1_72feff48-4856-44c8-a46d-d3de8a452d07.png?v=1778554294',
    'https://cdn.shopify.com/s/files/1/0660/0527/0775/files/20250930-p2_503d9b4f-bc03-463b-abf9-6a38726d3599.png?v=1778554294',
    'https://cdn.shopify.com/s/files/1/0660/0527/0775/files/20250930-p3_c0a9961d-ac5f-426f-bf7a-6034ed264c9a.png?v=1778554294',
//   'https://cdn.shopify.com/s/files/1/0726/3715/3597/files/202508132-b1.png',
//   'https://cdn.shopify.com/s/files/1/0726/3715/3597/files/202508132-b2.png',
//   'https://cdn.shopify.com/s/files/1/0726/3715/3597/files/202508132-b3.png',
//   'https://cdn.shopify.com/s/files/1/0726/3715/3597/files/202508132-b4.png',
]

function cutDownTime() {
  let nowTime = new Date()
  let endTime = new Date(endTimeG)

  let leftTime = endTime.getTime() - nowTime.getTime()
  if (leftTime < 0) {
    setupNewCountdown()
    leftTime = 0
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60)
  leftH = leftH >= 10 ? leftH : '0' + leftH
  leftM = leftM >= 10 ? leftM : '0' + leftM
  leftS = leftS >= 10 ? leftS : '0' + leftS

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  }
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9)
  const currentTime = new Date()
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
}
let intervalId

function getCutDownTime() {
  setupNewCountdown()
  if (intervalId) clearInterval(intervalId)
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime()
    $('.sp_hour').html(cutDownTimeText.hour)
    $('.sp_minute').html(cutDownTimeText.minute)
    $('.sp_second').html(cutDownTimeText.second)
  }, 1000)
}

getCutDownTime()

function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
  })

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach(subArray => {
        subArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach(url => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    new Swiper('.mySwiper', {
      slidesPerView: 1.7,
      spaceBetween: 35,
      loop: true, //循环滚动
      freeMode: true,
      speed: 6500, //匀速时间
      autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: true,
      },
      allowTouchMove: false,
    })

    // 第一个Swiper - CPL Anti-Glare
    const swiper1 = new Swiper('.sp-swiper1', {
      autoplay: {
        disableOnInteraction: false,
        delay: 2500,
      },
      spaceBetween: 0,
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: true,
      pagination: {
        el: '.sp-pagination',
        clickable: true,
      },
      on: {
        slideChange: function () {
          // 获取对应的sp-content
          const spContent = document.querySelector(
            '.sp-part4 .sp-content:not([style*="top"])'
          )
          if (spContent) {
            // 移除所有active类
            const items = spContent.querySelectorAll('div')
            items.forEach(item => item.classList.remove('active'))
            // 给当前索引的项添加active类
            const currentIndex = this.realIndex
            if (items[currentIndex]) {
              items[currentIndex].classList.add('active')
            }
          }
        },
      },
    })

    // 第二个Swiper - 8-Point Star Effect
    const swiper2 = new Swiper('.sp-swiper2', {
      autoplay: {
        disableOnInteraction: false,
        delay: 2500,
      },
      spaceBetween: 0,
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: true,
      pagination: {
        el: '.sp-pagination',
        clickable: true,
      },
      on: {
        slideChange: function () {
          // 获取对应的sp-content（有top样式的）
          const spContent = document.querySelector(
            '.sp-part4 .sp-content[style*="top"]'
          )
          if (spContent) {
            // 移除所有active类
            const items = spContent.querySelectorAll('div')
            items.forEach(item => item.classList.remove('active'))
            // 给当前索引的项添加active类
            const currentIndex = this.realIndex
            if (items[currentIndex]) {
              items[currentIndex].classList.add('active')
            }
          }
        },
      },
    })

    new Swiper('.sp-swiper3', {
      autoplay: {
        disableOnInteraction: false,
        delay: 2500,
      },
      spaceBetween: 0,
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: true,
      pagination: {
        el: '.sp-pagination',
        clickable: true,
      },
    })

    // 为sp-content中的按钮添加点击事件
    // 第一个sp-content的按钮点击事件
    const firstSpContent = document.querySelector(
      '.sp-part4 .sp-content:not([style*="top"])'
    )
    if (firstSpContent) {
      const buttons = firstSpContent.querySelectorAll('div')
      buttons.forEach((button, index) => {
        button.addEventListener('click', function () {
          // 移除所有active类
          buttons.forEach(btn => btn.classList.remove('active'))
          // 添加active类到当前按钮
          this.classList.add('active')
          // 切换到对应的slide
          swiper1.slideTo(index)
        })
      })
    }

    // 第二个sp-content的按钮点击事件
    const secondSpContent = document.querySelector(
      '.sp-part4 .sp-content[style*="top"]'
    )
    if (secondSpContent) {
      const buttons = secondSpContent.querySelectorAll('div')
      buttons.forEach((button, index) => {
        button.addEventListener('click', function () {
          // 移除所有active类
          buttons.forEach(btn => btn.classList.remove('active'))
          // 添加active类到当前按钮
          this.classList.add('active')
          // 切换到对应的slide
          swiper2.slideTo(index)
        })
      })
    }
    // let prods = window.product
    // let price1 = prods[0].price / 100
    // let price2 = prods[0].compare_at_price / 100
let prods = window.product
    function getCur() {
      let color = $('#sp-color div.active').attr('data-val')
      let type = $('#sp-type div.active').attr('data-val')
      return prods.filter(
        // item => item.option1 == color && item.option2 == type
        item => item.option1 == color
      )[0]
    }
    function changePrice() {
      let num = $('#calcNumber').val()
      let price = ((getCur().price * num) / 100000).toFixed(3)
      let compare = ((getCur().compare_at_price * num) / 100000).toFixed(3)
      // price = (price + '').replace('.', ',')
      // compare = (compare + '').replace('.', ',')
      $('#sp_price1').html(price)
      $('#sp_price2').html(compare)
      let off_price = (
        (100 * (getCur().compare_at_price - getCur().price)) /
        getCur().compare_at_price
      ).toFixed(0)
      //   off_price = (off_price + '').replace('.', ',')
      $('.product-part .sp-row .sp-p span').html(off_price)
    }
    $('.sp-btn-style').click(function () {
      let num = $('#calcNumber').val()
      window.location.href = '/cart/' + getCur().id + ':' + num
      //   $.post('/api/checkout/order', {
      //   line_items: [{
      //     quantity: $("#calcNumber").val(), // 数量
      //     variant_id: getCur().id, // 子商品id
      //     note: '', // 备注
      //   }],
      //   refer_info: { source: 'buy_now' }
      // }, function (ret) {
      //   if (ret.state === 'success') {
      //     return (window.safeHref = '/checkout/' + ret.data.order_token + '?step=contact_information');
      //   } else {
      //     $.toast.show({
      //       content:
      //         {
      //           '30003': "Some items have been removed, please re-order",
      //           'line_items_variant_withdraw': "Some items have been sold out, please re-order",
      //           'line_items_variant_sold_out': "Some items are not in stock, please re-order"
      //         }[ret.state] || ret.errors[0] || "Some items information has been updated, please re-order"
      //     });
      //   }
      // });
    })

    $('.sp-reduce').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) - 1
      if (num > 0) {
        input.value = num
      }
      changePrice()
    })
    $('.sp-add').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) + 1
      input.value = num
      changePrice()
    })

    $('.sp-option').click(function () {
      $(this).siblings().removeClass('active')
      $(this).addClass('active')

      let colorOptions = $('#sp-color .sp-option.active').index()
      let typeOptions = $('#sp-type .sp-option.active').index()

      let _index = colorOptions
      if (typeOptions) {
        $('.product-part .sp-img-p').css({
          maxWidth: '871px',
        })
      } else {
        $('.product-part .sp-img-p').css({
          maxWidth: '746px',
        })
      }
      $('.product-part .sp-img-p')[0].src = spImgList[_index]
      changePrice()
    })
        // 购物车加购动效
    $('.cart-btn').click(function () {
      $(this).children('img').addClass('on')
      $('.sp-header-top .sp-cart .num').show()
      setTimeout(function () {
        $('.cart-btn').children('img').removeClass('on')
      }, 500)
      $('.sp-header-top .sp-cart').addClass('on')
      setTimeout(function () {
        $('.sp-header-top .sp-cart').removeClass('on')
      }, 500)
    })

    let initNum = 0
    $('.product-part .cart-btn').click(function () {
      let spNum = $('.product-part #calcNumber')[0].value
      initNum += Number(spNum)

      // $("#calcNumber").val(1);
      var data = {
        id: getCur().id,
        quantity: spNum,
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
            $('#cardNum').html(result.item_count)
            $('#cardNum').removeClass('sp-gray')
          })
        },
        dataType: 'json',
      })
      // $('#cardNum').html(initNum)
      // $('#cardNum').removeClass('sp-gray')
      // handleAddToCart(initNum);

      var img = $('.product-part .sp-img-p')
      // var img = $(".product-part .sp-swiper .swiper-slide-active .sp-img");

      var flyer = img[0].cloneNode(true)
      flyer.classList.add('sp_clone')

      $('.product-part').append(flyer)
      $('.sp_clone').css({
        width: img[0].width,
        height: img[0].height,
        background: '#e7e9ef',
        position: 'fixed',
        top: img[0].offsetTop,
        left: img.offset().left,
        'z-index': '99',
      })

      let finish = $('.sp-cart')
      $('.sp_clone').animate(
        {
          // top: finish[0].offsetTop,
          top: finish[0].offsetTop + $('.time-part').height(),
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        500,
        'linear',
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach()
            }
          )
        }
      )
    })
    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            325 * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span')
    const paragraph = gradually.querySelector('.sp-detail')

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`

              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
            })

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade2 0.5s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }

  // 环形旋转木马
  // var slideW = 360; //一张图300px, 每面四张角度22.5（PI/8），中心角度PI/16
  // var radius = (slideW * 0.5) / Math.sin(Math.PI / 16); //半径。圆心并不是视点中心，视点在1200px
  var slideW = 340 //一张图300px, 每面四张角度22.5（PI/8），中心角度PI/16
  var radius = (slideW * 0.5) / Math.sin(Math.PI / 12) //半径。圆心并不是视点中心，视点在1200px

  carouselSwiper = new Swiper('#carousel .swiper', {
    watchSlidesProgress: true,
    slidesPerView: 'auto',
    centeredSlides: false,
    loop: true,
    loopedSlides: 3,
    grabCursor: true,
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
    freeMode: true,
    speed: 5000, //匀速时间
    on: {
      progress: function (swiper, progress) {
        for (i = 0; i < this.slides.length; i++) {
          var slide = this.slides.eq(i)
          var slideProgress = this.slides[i].progress
          const translateX =
            (slideProgress + 1) *
              (slideW / 4 -
                (Math.cos((slideProgress + 1) * (1 / 6) * Math.PI) *
                  slideW *
                  1.2) /
                  4) +
            'px' //调整图片间距，根据图片宽度改变数值实现自适应
          const rotateY = (slideProgress + 1) * 30 //图片角度
          const translateZ =
            radius -
            Math.cos((slideProgress + 1) * (1 / 6) * Math.PI) * radius -
            150 +
            'px' //调整图片远近，刚好4个在画框内
          slide.transform(
            'translateX(' +
              translateX +
              ') translateZ(' +
              translateZ +
              ') rotateY(' +
              rotateY +
              'deg)'
          )
        }
      },
      setTransition: function (swiper, transition) {
        for (var i = 0; i < this.slides.length; i++) {
          var slide = this.slides.eq(i)
          slide.transition(transition)
        }
      },
    },
  })
}

mainRender()
